import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { ICardTransactionFilterFormFields } from '@/store/types/card-transactions.type';
import { cardTransactionPaymentStatus } from '@/features/cards/store/models/card.model';

import { ICheckField } from '@/ui-kit/table-filters/filters.type';

export function mapCardTransactionStatus(value) {
  return {
    paymentStatus: value,
  };
}

export function useCardTransactionStatusField(
  methods: UseFormReturn<ICardTransactionFilterFormFields>,
  onChange,
): ICheckField {
  const { t } = useTranslation();

  const handleStatusChange = useCallback(
    (value: ICardTransactionFilterFormFields['status']) => {
      methods.setValue('status', value);
      onChange();
    },
    [onChange, methods],
  );

  const statusOptions: TOption[] = Object.entries(cardTransactionPaymentStatus).map(([key, status]) => ({
    label: t(`pages.currentProfiles.cards.transactions.table.status.${status}`),
    value: key,
  }));

  const statusValue = statusOptions.filter((option) => methods.watch('status')?.includes(option.value as string));

  return {
    values: statusValue,
    handleChange: handleStatusChange,
    options: statusOptions,
  };
}
